import * as React from 'react'

// Import logos
import allianzLogo from '#app/assets/images/logos/insurance/allianz.svg'
import atmLogo from '#app/assets/images/logos/insurance/atm.svg'
import bbvaLogo from '#app/assets/images/logos/insurance/bbva.svg'
import cajaGeneralLogo from '#app/assets/images/logos/insurance/caja_general.svg'
import cnpLogo from '#app/assets/images/logos/insurance/cnp.svg'
import colonSegurosLogo from '#app/assets/images/logos/insurance/colon-seguros.svg'
import dignaLogo from '#app/assets/images/logos/insurance/digna.svg'
import evolucionSegurosLogo from '#app/assets/images/logos/insurance/evolucionseguros.svg'
import expertaLogo from '#app/assets/images/logos/insurance/experta.svg'
import fedPatLogo from '#app/assets/images/logos/insurance/FedPat.svg'
import galenoLogo from '#app/assets/images/logos/insurance/galeno.svg'
import galiciaLogo from '#app/assets/images/logos/insurance/galicia.svg'
import hdiSegurosLogo from '#app/assets/images/logos/insurance/HDI-Seguros.svg'
import holandoLogo from '#app/assets/images/logos/insurance/holando.svg'
import integrityLogo from '#app/assets/images/logos/insurance/Integrity.svg'
import laEquitativaLogo from '#app/assets/images/logos/insurance/la_equitativa.svg'
import libraLogo from '#app/assets/images/logos/insurance/libra.svg'
import lifeLogo from '#app/assets/images/logos/insurance/life.svg'
import logoLightLogo from '#app/assets/images/logos/insurance/logo-light.svg'
import meridionalLogo from '#app/assets/images/logos/insurance/logo-Meridional.svg'
import mercantilAndinaLogo from '#app/assets/images/logos/insurance/mercantil_andina.svg'
import mistaLogo from '#app/assets/images/logos/insurance/mista.svg'
import paranaLogo from '#app/assets/images/logos/insurance/parana.svg'
import prevensionLogo from '#app/assets/images/logos/insurance/prevension.svg'
import providenciaLogo from '#app/assets/images/logos/insurance/providencia1.svg'
import provinciaLogo from '#app/assets/images/logos/insurance/provincia.svg'
import reconquistaLogo from '#app/assets/images/logos/insurance/reconquista.svg'
import rivadaviaLogo from '#app/assets/images/logos/insurance/rivadavia-seguros.svg'
import rusLogo from '#app/assets/images/logos/insurance/RUS-Rio-Uruguay-Seguros.svg'
import sanCristobalLogo from '#app/assets/images/logos/insurance/San-Cristobal-Seguros-logo.svg'
import sancorLogo from '#app/assets/images/logos/insurance/sancor.svg'
import swissMedicalLogo from '#app/assets/images/logos/insurance/swiss-medical-seguros.svg'
import triunfoLogo from '#app/assets/images/logos/insurance/triunfo.svg'
import zurichLogo from '#app/assets/images/logos/insurance/zurich.svg'
import { cn } from '#app/utils/misc.tsx'

interface Logo {
	src: string
	alt: string
	className?: string
}

const logos: Logo[] = [
	{ src: allianzLogo, alt: 'Allianz', className: 'h-[46px] w-[70px]' },
	{ src: atmLogo, alt: 'ATM', className: 'size-[69px]' },
	{ src: bbvaLogo, alt: 'BBVA', className: 'h-[52px] w-[90px]' },
	{ src: cajaGeneralLogo, alt: 'Caja General', className: 'h-[26px] w-[80px]' },
	{ src: logoLightLogo, alt: 'Logo Light', className: 'h-[28px] w-[73px]' },
	{ src: cnpLogo, alt: 'CNP Assurances', className: 'h-[43px] w-[60px]' },
	{
		src: colonSegurosLogo,
		alt: 'Colón Seguros',
		className: 'h-[33px] w-[58px]',
	},
	{ src: dignaLogo, alt: 'Digna', className: 'h-[51px] w-[68px]' },
	{ src: expertaLogo, alt: 'Experta', className: 'h-[20px] w-[122px]' },
	{
		src: evolucionSegurosLogo,
		alt: 'Evolución Seguros',
		className: 'h-[25px] w-[92px]',
	},
	{ src: fedPatLogo, alt: 'FedPat', className: 'h-[33px] w-[130px]' },
	{ src: galenoLogo, alt: 'Galeno', className: 'h-[33px] w-[116px]' },
	{ src: galiciaLogo, alt: 'Galicia', className: 'h-[34px] w-[139px]' },
	{ src: hdiSegurosLogo, alt: 'HDI Seguros', className: 'h-[33px] w-[53px]' },
	{ src: integrityLogo, alt: 'Integrity', className: 'size-[73px]' },
	{
		src: laEquitativaLogo,
		alt: 'La Equitativa',
		className: 'h-[29px] w-[124px]',
	},
	{ src: holandoLogo, alt: 'La Holando', className: 'size-[69px]' },
	{ src: libraLogo, alt: 'Libra', className: 'h-[28px] w-[76px]' },
	{ src: lifeLogo, alt: 'Life', className: 'h-[35px] w-[72px]' },
	{
		src: mercantilAndinaLogo,
		alt: 'Mercantil Andina',
		className: 'h-[31px] w-[121px]',
	},
	{ src: meridionalLogo, alt: 'Meridional', className: 'h-[39px] w-[99px]' },
	{ src: mistaLogo, alt: 'Mista', className: 'h-[39px] w-[62px]' },
	{ src: paranaLogo, alt: 'Paraná', className: 'h-[28px] w-[76px]' },
	{ src: prevensionLogo, alt: 'Prevensión', className: 'h-[34px] w-[89px]' },
	{ src: providenciaLogo, alt: 'Providencia', className: 'h-[52px] w-[83px]' },
	{ src: provinciaLogo, alt: 'Provincia', className: 'h-[28px] w-[90px]' },
	{ src: reconquistaLogo, alt: 'Reconquista', className: 'h-[22px] w-[113px]' },
	{ src: rivadaviaLogo, alt: 'Rivadavia Seguros', className: 'size-[64px]' },
	{ src: rusLogo, alt: 'RUS', className: 'h-[30px] w-[87px]' },
	{
		src: sanCristobalLogo,
		alt: 'San Cristóbal Seguros',
		className: 'h-[29px] w-[82px]',
	},
	{ src: sancorLogo, alt: 'Sancor', className: 'h-[23px] w-[91px]' },
	{
		src: swissMedicalLogo,
		alt: 'Swiss Medical',
		className: 'h-[51px] w-[105px]',
	},
	{ src: triunfoLogo, alt: 'Triunfo', className: 'h-[51px] w-[92px]' },
	{ src: zurichLogo, alt: 'Zurich', className: 'h-[46px] w-[121px]' },
]

export interface SegurosLogosSectionProps {
	/**
	 * Additional CSS classes
	 */
	className?: string
}

const SegurosLogosSection = React.forwardRef<
	HTMLElement,
	SegurosLogosSectionProps
>(({ className, ...props }, ref) => {
	return (
		<section
			ref={ref}
			className={cn('bg-white px-4 py-12 md:px-6 md:py-16', className)}
			{...props}
		>
			<div className="mx-auto flex w-full max-w-[1200px] flex-wrap content-center items-center justify-center gap-4 md:gap-8">
				{logos.map((logo, index) => (
					<div key={index} className={cn('relative shrink-0', logo.className)}>
						<img
							src={logo.src}
							alt={logo.alt}
							className="pointer-events-none size-full object-contain object-center"
						/>
					</div>
				))}
			</div>
		</section>
	)
})

SegurosLogosSection.displayName = 'SegurosLogosSection'

export { SegurosLogosSection }
